import React, { useEffect } from "react";

const TrackingScripts = () => {
  // for adobe tags issue testing
  // useEffect(() => {
  //   if (document.getElementById("gtag-salcorp")) return;

  //   window.dataLayer = window.dataLayer || [];
  //   function gtag() { window.dataLayer.push(arguments); }
  //   window.gtag = gtag;

  //   const userData = localStorage.getItem("userData");
  //   const retrievedData = userData ? JSON.parse(userData) : null;

  //   gtag("js", new Date());

  //   // Remarketing config - keep default page view
  //   gtag("config", "AW-961178487");
  //   gtag("config", "DC-8971752");

  //   // AW-736858127 — disable auto page view, send manually
  //   gtag("config", "AW-736858127", {
  //     send_page_view: false
  //   });
  //   gtag("event", "page_view", {
  //     send_to: "AW-736858127",
  //     page_title: document.title,
  //     page_location: window.location.href
  //   });
  //   gtag("event", "conversion", { send_to: "AW-736858127/r6u3CN_v1J4YEI-grt8C" });

  //   // AW-11185178531 — ECL with phone, disable auto page view, send manually
  //   if (retrievedData?.mobile) {
  //     gtag("set", "user_data", { phone_number: retrievedData.mobile });
  //     gtag("config", "AW-11185178531", {
  //       allow_enhanced_conversions: true,
  //       send_page_view: false
  //     });
  //   } else {
  //     gtag("config", "AW-11185178531", {
  //       send_page_view: false
  //     });
  //   }

  //   gtag("event", "page_view", {
  //     send_to: "AW-11185178531",
  //     page_title: document.title,
  //     page_location: window.location.href
  //   });
  //   gtag("event", "conversion", { send_to: "AW-11185178531/BOlHCMSH9KEYEKOPwdUp" });
  //   gtag("event", "form_submit", { send_to: "AW-11185178531" });

  //   // DV360 Floodlight
  //   gtag("event", "conversion", {
  //     allow_custom_scripts: true,
  //     send_to: "DC-8971752/invmedia/salcor03+standard",
  //   });

  //   const script = document.createElement("script");
  //   script.id = "gtag-salcorp";
  //   script.async = true;
  //   script.src = "https://www.googletagmanager.com/gtag/js?id=AW-961178487";
  //   document.head.appendChild(script);

  //   function removeUserData() {
  //     localStorage.removeItem("userData");
  //   }
  //   setTimeout(removeUserData, 4000);
  // }, []);

  // useEffect(() => {
  //   const userData = localStorage.getItem("userData");
  //   const retrievedData = userData ? JSON.parse(userData) : null;

  //   const fireGtags = () => {
  //     if (!window.gtag) {
  //       setTimeout(fireGtags, 300);
  //       return;
  //     }

  //     window.gtag("js", new Date());

  //     // Remarketing configs
  //     window.gtag("config", "AW-961178487", { send_page_view: true });
  //     window.gtag("config", "AW-848956189", { send_page_view: true });
  //     window.gtag("config", "AW-736858127", { send_page_view: true });

  //     // Manually fire page_view for the two that aren't auto-firing
  //     window.gtag("event", "Page View", { send_to: "AW-11185178531" });
  //     window.gtag("event", "Page View", { send_to: "AW-736858127" });

  //     // ECL on AW-11185178531
  //     if (retrievedData?.mobile) {
  //       window.gtag("config", "AW-11185178531", { allow_enhanced_conversions: true, send_page_view: true });
  //       window.gtag("set", "user_data", { phone_number: retrievedData.mobile });
  //     } else {
  //       window.gtag("config", "AW-11185178531", { send_page_view: true });
  //     }

  //     // DV 360 config
  //     window.gtag("config", "DC-8971752");

  //     // Conversion events
  //     window.gtag("event", "conversion", { send_to: "AW-11185178531/BOlHCMSH9KEYEKOPwdUp" });
  //     window.gtag("event", "conversion", { send_to: "AW-736858127/r6u3CN_v1J4YEI-grt8C" });
  //     window.gtag("event", "form_submit", { send_to: "AW-11185178531" });

  //     // DV 360 Floodlight conversion
  //     window.gtag("event", "conversion", {
  //       allow_custom_scripts: true,
  //       send_to: "DC-8971752/invmedia/salcor03+standard",
  //     });

  //     setTimeout(() => localStorage.removeItem("userData"), 4000);
  //   };

  //   fireGtags();
  // }, []);

  useEffect(() => {
    const userData = localStorage.getItem("userData");
    const retrievedData = userData ? JSON.parse(userData) : null;
 
    const fireGtags = () => {
      if (!window.gtag) {
        setTimeout(fireGtags, 300);
        return;
      }
 
      window.gtag("js", new Date());
 
      // Remarketing configs
      window.gtag("config", "AW-961178487", { send_page_view: true });
      window.gtag("config", "AW-848956189", { send_page_view: true });
 
      // Manually fire page_view for the two that aren't auto-firing
      window.gtag("event", "Page View", { send_to: "AW-11185178531" });
      window.gtag("event", "Page View", { send_to: "AW-736858127" });
 
      // ECL on AW-11185178531
      if (retrievedData?.mobile) {
        window.gtag("config", "AW-11185178531", { allow_enhanced_conversions: true, send_page_view: true });
        window.gtag("config", "AW-736858127", { allow_enhanced_conversions: true, send_page_view: true });
 
        window.gtag("set", "user_data", { phone_number: retrievedData.mobile });
      } else {
        window.gtag("config", "AW-11185178531", { send_page_view: true });
        window.gtag("config", "AW-736858127", { send_page_view: true });
      }
 
      // DV 360 config
      window.gtag("config", "DC-8971752");
 
      // Conversion events
      window.gtag("event", "conversion", { send_to: "AW-11185178531/BOlHCMSH9KEYEKOPwdUp" });
      window.gtag("event", "conversion", { send_to: "AW-736858127/r6u3CN_v1J4YEI-grt8C" });
      window.gtag("event", "form_submit", { send_to: "AW-11185178531" });
      window.gtag("event", "form_submit", { send_to: "AW-736858127" });
     
      // DV 360 Floodlight conversion
      window.gtag("event", "conversion", {
        allow_custom_scripts: true,
        send_to: "DC-8971752/invmedia/salcor03+standard",
      });
 
      setTimeout(() => localStorage.removeItem("userData"), 4000);
    };
 
    fireGtags();
  }, []);

  // Facebook Pixel — Remarketing (PageView) + Conversion (Sal-Corp-EL, SA-ApplyNow)
  // useEffect(() => {
  //   if (window.fbEventFired) return;
  //   window.fbEventFired = true;

  //   if (!window.fbq) {
  //     (function (f, b, e, v, n, t, s) {
  //       n = f.fbq = function () {
  //         n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  //       };
  //       if (!f._fbq) f._fbq = n;
  //       n.push = n;
  //       n.loaded = true;
  //       n.version = "2.0";
  //       n.queue = [];
  //       t = b.createElement(e);
  //       t.async = true;
  //       t.src = v;
  //       s = b.getElementsByTagName(e)[0];
  //       s.parentNode.insertBefore(t, s);
  //     })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  //   }

  //   window.fbq("init", "1109423764622443");
  //   window.fbq("track", "PageView");                  // Remarketing
  //   window.fbq("trackCustom", "SalCorp-EL");          // Conversion
  //   window.fbq("trackCustom", "SA-ApplyNow");
  // }, []);
  useEffect(() => {
    if (window.fbThankYouFired) return; // 👈 separate flag for thankyou
    window.fbThankYouFired = true;

    const fireFbq = () => {
      if (!window.fbq) {
        setTimeout(fireFbq, 300);
        return;
      }

      window.fbq("init", "1109423764622443");
      window.fbq("track", "PageView");           // Remarketing
      window.fbq("trackCustom", "Sal-Corp-EL");  // Conversion
      window.fbq("trackCustom", "SA-ApplyNow");  // Conversion
    };

    fireFbq();
  }, []);
  // LinkedIn Insight Tag — partner ID 5534113

  useEffect(() => {
    const fireLinkedIn = () => {
      if (!window.lintrk) {
        setTimeout(fireLinkedIn, 300);
        return;
      }
      window.lintrk("track"); // fires page view on thankyou
    };
    fireLinkedIn();
  }, []);



  // Bing UET Tags — 97231496 and 97231495
  useEffect(() => {
    const fireBing = () => {
      if (!window.uetq || !window.uetq2) {
        setTimeout(fireBing, 300);
        return;
      }
      window.uetq.push("pageLoad");
      window.uetq2.push("pageLoad");
    };
    fireBing();
  }, []);

  // MS Clarity — vn9yec4mqm
  useEffect(() => {
    (function (c, l, a, r, i, t, y) {
      c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
      t = l.createElement(r); t.async = 1;
      t.src = "https://www.clarity.ms/tag/" + i;
      y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", "vn9yec4mqm");
  }, []);

  // MS Clarity — vn9y1utxz2
  useEffect(() => {
    (function (c, l, a, r, i, t, y) {
      c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
      t = l.createElement(r); t.async = 1;
      t.src = "https://www.clarity.ms/tag/" + i;
      y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", "vn9y1utxz2");
  }, []);

  return null;
};

export default TrackingScripts;
